export default __webpack_public_path__ + "static/media/width.a7277f13.png";